export const BREAKPOINT_DESKTOP = 984;

export const PAGE_HEADER_CSS = {
  'abyss-page-header-root': {
    position: 'fixed',
    height: 'min-content',
    zIndex: 1075,
  },
  'abyss-page-header-logo': {
    flexShrink: '0.5',
    flexGrow: 0,
    '.abyss-brandmark': {
      minWidth: '115px',
    },
  },
  'abyss-page-header-container': {
    minHeight: '108px',
  },
  'abyss-page-header-drawer-selected-menu-name': {
    fontWeight: 'bold',
    fontSize: 'x-large',
  },
  'abyss-page-header-bottom-nav-menu': {
    padding: '0px 16px 0px 16px',
    position: 'relative',
    zIndex: 950,
    maxWidth: '1380px',
    justifyContent: 'center',
    '&:focus': {
      boxShadow: 'none',
      outline: 'none',
    },
  },
  'abyss-page-header-top-nav-menu': {
    padding: '0px 8px 0px 8px',
    position: 'relative',
    zIndex: 1300,
    '&:focus': {
      boxShadow: 'none',
      outline: 'none',
    },
  },
  'abyss-page-header-drawer-menu-item-button': {
    '&:focus': {
      boxShadow: 'none',
      outline: 'none',
    },
  },
  'abyss-page-header-drawer-selection-content': {
    paddingBottom: '16px',
  },
  'abyss-page-header-vertical-rule': {
    margin: 0,
    background: 'linear-gradient(90deg, transparent, $gray3 50%, $gray3)',
  },
};

export const TOOLBAR_STYLE = {
  minHeight: '62px',
  alignItems: 'center',
  marginLeft: 0,
  width: '100%',
};

export const NAV_MENU_WRAPPER_DESKTOP_STYLE = {
  zIndex: -1,
  position: 'absolute',
  top: '132px',
  width: '100%',
  height: '52px',
};

export const NAV_MENU_WRAPPER_MOBILE_STYLE = {
  zIndex: -1,
  position: 'absolute',
  top: '39px',
  left: '29px',
  width: '30px',
  height: '30px',
};

export const VERTICAL_SPACER_HEIGHT = '180px';
export const VERTICAL_SPACER_COLLAPSED_HEIGHT = '108px';
